import React from 'react';
import toast, { Toaster } from 'react-hot-toast';
import * as Utils from "../../../../inc/Utils";
import Role from "../../../../inc/Role";
import {useParams} from "react-router";
import {Config} from "../../../../Config";
import GroupProjectItemCreate from "./GroupProjectItemCreate";
import GroupPromotionItemCreate from "./GroupPromotionItemCreate";
import GroupSpecialItemCreate from "./GroupSpecialItemCreate";
import GroupMasterURLItemCreate from "./GroupMasterURLItemCreate";

export default function GenerateGroupCampaignItemCreate() {
    const roles = new Role();

    let {encode} = useParams();
    let decode = Utils.decodeItem(encode);
    let generateGroupId = decode.generateGroupId;
    let generateGroupTitle = decode.generateGroupTitle;
    let generateGroupCampaignId = decode.generateGroupCampaignId;

    let backPath = '/generateGroupCampaign/' + Utils.encodeItem({generateGroupId: generateGroupId, generateGroupTitle: generateGroupTitle});

    let [typeId, setTypeId] = React.useState(null);
    let [masterUrlFor, setMasterUrlFor] = React.useState(null);

    React.useEffect(() => {
        (async function() {
            try {
                const row = await getGroupView(generateGroupId);
                setTypeId(row.typeId);
                setMasterUrlFor(row.masterUrlFor);
            } catch (e) {
                toast.error(e.message);
            }
        })();
    }, []);

    async function getGroupView(id) {
        const response = await fetch(Config.url.API_URL +'/api/generateGroup/view', {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                'x-access-token': roles.accessToken
            },
            body: JSON.stringify({
                id: id
            })
        });

        if(response.ok) {
            return response.json();
        }
        else {
            return response.json().then(err => Promise.reject(err));
        }
    }

    return (
        <main>
            <div className="row table-toolbar mb-2">
                <div className="col-6 align-self-center">
                    <div className="h6 d-inline"><span className="text-success">&#8226;</span> Generate Group</div>
                    <span className="ms-1">/</span> <span className="fw-bold">Campaign</span>
                    <span className="ms-1">/</span> <span className="text-muted">Create</span>
                </div>
            </div>
            <div className="rounded bg-white p-4 shadow">
                <div className="row">
                    <div className="col-12 col-md-6">
                        <form>
                            {
                                typeId === Utils.GENERATE_TYPE_PROJECT ? <GroupProjectItemCreate
                                    typeId={typeId}
                                    generateGroupId={generateGroupId}
                                    backPath={backPath}
                                    generateGroupCampaignId={generateGroupCampaignId}
                                    masterUrlFor={masterUrlFor} /> : ''
                            }
                            {
                                typeId === Utils.GENERATE_TYPE_PROMOTION ? <GroupPromotionItemCreate
                                    typeId={typeId}
                                    generateGroupId={generateGroupId}
                                    backPath={backPath}
                                    generateGroupCampaignId={generateGroupCampaignId}
                                    masterUrlFor={masterUrlFor}  /> : ''
                            }
                            {
                                typeId === Utils.GENERATE_TYPE_SPECIAL ? <GroupSpecialItemCreate
                                    typeId={typeId}
                                    generateGroupId={generateGroupId}
                                    backPath={backPath}
                                    generateGroupCampaignId={generateGroupCampaignId}
                                    masterUrlFor={masterUrlFor}  /> : ''
                            }
                            {
                                typeId === Utils.GENERATE_TYPE_MASTER_URL ? <GroupMasterURLItemCreate
                                    typeId={typeId}
                                    generateGroupId={generateGroupId}
                                    backPath={backPath}
                                    generateGroupCampaignId={generateGroupCampaignId}
                                    masterUrlFor={masterUrlFor}  /> : ''
                            }
                        </form>
                    </div>
                    <div className="col-12 col-md-6"></div>
                </div>
            </div>
        </main>
    );
} 